// /hideout 비밀번호 입력 성공 여부 — 같은 탭 세션 동안 유지.
// /todo, /daily, /study 진입 시 RequireHideoutAuth 가드가 이 값을 검사한다.
const KEY = 'hideout.unlocked';

export const isHideoutUnlocked = (): boolean => {
  if (typeof window === 'undefined') return false;
  try {
    return window.sessionStorage.getItem(KEY) === '1';
  } catch {
    return false;
  }
};

export const markHideoutUnlocked = (): void => {
  if (typeof window === 'undefined') return;
  try {
    window.sessionStorage.setItem(KEY, '1');
  } catch {
    /* sessionStorage 사용 불가 환경(시크릿 모드 등) 무시 */
  }
};
